import Constants from 'core/constants';
export default {
  layout: 'dashboards',
  controller: 'dashboards',
  permissions: 'portal_access',
  icon: 'navDashboards',
  routeName: Constants.ROUTE_NAME_LABELS.DASHBOARDS,
  label: 'Dashboards',
  ':id': {
    controller: 'dashboards',
    layout: 'dashboard',
    card: {
      new: {
        ':id': {
          layout: 'dashboard-detail',
        },
      },
      ':id': {
        layout: 'dashboard-detail',
      },
    },
    schedule: {
      ':id': {
        layout: 'dashboard',
      },
    },
  },
  new: {
    label: 'New Dashboard',
    layout: 'create-new-dashboard',
    controller: 'dashboards',
  },
};
